import { getMeta } from 'lambda-dom'
import { prop } from 'ramda'

import { axios } from '@app-bootstrappers'
import { InfoWindowMarkerComponent } from '@app-components'
import { mapPinImage } from '@app-config'
import { InfoWindowMarker, MapLocationData, MapLocationQuery } from '@app-types'

export const createWindowMarker = (
    locationData: MapLocationData,
): InfoWindowMarker => new InfoWindowMarkerComponent({
    position: locationData.coordinates,
    icon: mapPinImage,
}, {
    content: locationData.infoWindowHTML,
})

export const getCompanyLocations = (
    filters: Partial<MapLocationQuery> | FormData,
): Promise<MapLocationData[] | null | undefined> => axios
    .post<MapLocationData[]>('/contact/locations', filters)
    .then(prop('data'))

declare global {
    // noinspection JSUnusedGlobalSymbols
    interface Window {
        mapsApiReady: (() => void) | undefined
    }
}

export const loadGoogleMapsApi = async (): Promise<void> => {
    return new Promise((resolve) => {
        window.mapsApiReady = () => {
            resolve()
            window.mapsApiReady = undefined
        }

        const mapsApiKey = getMeta('maps-key')
        const scriptElement = document.createElement('script')

        scriptElement.src = `https://maps.googleapis.com/maps/api/js?key=${mapsApiKey}&callback=mapsApiReady`
        document.body.appendChild(scriptElement)
    })
}
